// extracted by mini-css-extract-plugin
export default {"servicesPage":"Services_servicesPage__boB8b","serviceCard":"Services_serviceCard__38UxZ"};